// Module generated from Markdown by Markdown Component Loader v1.1.0
import React from 'react';
import PropTypes from 'prop-types';

MarkdownComponent.propTypes = {
  className: PropTypes.string,
  style: PropTypes.object
};

function MarkdownComponent(props) {
  const { className, style } = props;

  return (
    <div className={className} style={style}>
      <h3 id="july-21-2020">July 21, 2020</h3>
      <p>Our Urgent Care Eligibility API was deactivated on July 21, 2020. The API and related documentation is no longer accessible. For more information, <a href="https://developer.va.gov/support/contact-us">contact us</a> or visit our <a href="https://groups.google.com/forum/m/#!forum/va-lighthouse">Google Developer Forum</a></p>
      <hr />
      <h3 id="july-13-2020">July 13, 2020</h3>
      <p>The Urgent Care Eligibility API is deprecated and scheduled for deactivation in the 3rd quarter of 2020.</p>
      <hr />
      <h3 id="june-10-2020">June 10, 2020</h3>
      <p>The optional query parameter <code>prompt</code> has been added to the authorization flow.</p>
      <ul>
      <li>Supported prompts: login. If specified, the user will be forced to provide credentials regardless of session state. If omitted, an existing active session with the identity provider may not require the user to provide credentials.</li>
      </ul>
      <p><a href="https://github.com/department-of-veterans-affairs/vets-saml-proxy/pull/111">View code changes(s)</a></p>
      <hr />
      <h3 id="july-30-2019">July 30, 2019</h3>
      <p>Launch of the Urgent Care Eligibility API</p>
    </div>
  );
};

export default MarkdownComponent;
